import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import posed, { PoseGroup } from "react-pose";
import { ScreenHeader } from "../Layout";
import RequestWishlistEmail from "./RequestWishlistEmail";
import { Product } from "../Products";

const PoseOverlay = posed.div({
  open: {
    delayChildren: 250,
    staggerChildren: 50
  },
  closed: { delay: 500 }
});

const PoseItem = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: 100, opacity: 0 }
});

class Wishlist extends PureComponent {
  static propTypes = {
    products: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
      })
    ).isRequired,
    onToggleWishlist: PropTypes.func,
    onOpenVideo: PropTypes.func,
    onBuyProduct: PropTypes.func,

    email: PropTypes.string,
    isRequesting: PropTypes.bool,
    onUpdateEmail: PropTypes.func,
    emailFormVisible: PropTypes.bool,
    onShowEmailForm: PropTypes.func,
    onHideEmailForm: PropTypes.func,
    onSubmitEmailform: PropTypes.func
  };

  static defaultProps = {
    products: [],
    onToggleWishlist: product => {},
    onOpenVideo: product => {},
    onBuyProduct: product => {},

    email: null,
    isRequesting: false,
    onUpdateEmail: () => {},
    emailFormVisible: false,
    onShowEmailForm: () => {},
    onHideEmailForm: () => {},
    onSubmitEmailform: () => {}
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    this.setState({ isOpen: true });
  }

  renderProduct = product => {
    const { onToggleWishlist, onOpenVideo, onBuyProduct } = this.props;

    return (
      <PoseItem key={product.id} className="wishlist-product-wrap">
        <Product
          product={product}
          compact={true}
          onToggleWishlist={onToggleWishlist}
          onOpenVideo={onOpenVideo}
          onBuyProduct={onBuyProduct}
        />
      </PoseItem>
    );
  };

  renderProducts = () => {
    if (this.props.products.length === 0) {
      return (
        <div className="content">
          <div className="empty-wrap">
            <i className="icon-warning" />
            <span>{this.props.t("wishlist:no_products")}</span>
          </div>
        </div>
      );
    }

    return (
      <PoseOverlay
        className="content"
        pose={this.state.isOpen ? "open" : "closed"}
      >
        <PoseGroup>
          {this.props.products.map(product => this.renderProduct(product))}
        </PoseGroup>
        <RequestWishlistEmail
          isVisible={this.props.emailFormVisible}
          onHide={this.props.onHideEmailForm}
          email={this.props.email ? this.props.email : ""}
          onUpdateEmail={this.props.onUpdateEmail}
          onSubmit={this.props.onSubmitEmailform}
        />
      </PoseOverlay>
    );
  };

  render() {
    const requestEmailIcon = () => {
      return (
        <a
          href="#show-request-email"
          role="button"
          onClick={event => {
            event.preventDefault();
            this.props.onShowEmailForm();
          }}
        >
          <i className="icon-envelope" style={{ fontSize: "32px" }} />
        </a>
      );
    };

    return (
      <div className="screen-container screen-wishlist">
        <ScreenHeader
          title={this.props.t("wishlist:screen_title")}
          right={this.props.products.length ? requestEmailIcon() : null }
        />
        {this.renderProducts()}
      </div>
    );
  }
}

export default withNamespaces(["wishlist", "common"], { wait: true })(Wishlist);
